import type { ReportExplorerConfiguration, ReportRequest } from '../../model';
import { serializeReportExplorerFilterValueLabels } from '../../reportFilters';
import type {
  buildChartReportRequest,
  buildTableReportRequest,
  buildTimeShiftReportRequest,
} from '../../reportRequest';
import type { SaveReportConfigPayload } from '../../../savedReports/model';

export function sameReportRequest(left: ReportRequest | null, right: ReportRequest) {
  // Both sides come from buildTableReportRequest, so key order is stable.
  return left !== null && JSON.stringify(left) === JSON.stringify(right);
}

/** The ran report with new dates: a date change reruns the last run table, not unrun selections. */
export function withReportDates(
  request: ReportRequest,
  dates: Pick<ReportRequest['filters'], 'dateRange' | 'dateFrom' | 'dateTo'>,
): ReportRequest {
  return { ...request, filters: { ...request.filters, ...dates } };
}

export function reportPayload(
  name: string,
  report: ReturnType<typeof buildTableReportRequest>,
  chartReport: ReturnType<typeof buildChartReportRequest>,
  timeShiftReport: ReturnType<typeof buildTimeShiftReportRequest>,
  reportFilters: ReportExplorerConfiguration['reportFilters'],
  sharedWith: string[],
): SaveReportConfigPayload {
  return {
    name,
    report,
    chartReport: timeShiftReport ? [chartReport, timeShiftReport] : [chartReport],
    settings: {
      filterValueLabels: serializeReportExplorerFilterValueLabels(reportFilters),
    },
    sharedWith,
  };
}
